function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("g", {
  id: "export-badges",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  id: "production",
  transform: "translate(-1062.000000, -38.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "card_visa",
  transform: "translate(1062.000000, 38.000000)"
}, /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle-11",
  fill: "#FFFFFE",
  x: 0,
  y: 0,
  width: 120,
  height: 80,
  rx: 4
}), /*#__PURE__*/React.createElement("g", {
  id: "Group-29",
  transform: "translate(16.142857, 26.150000)",
  fill: "#182E66"
}, /*#__PURE__*/React.createElement("polyline", {
  id: "Fill-1",
  points: "35.6040065 25.675 28.5714286 25.675 32.9666995 -2.30926389e-14 40 -2.30926389e-14 35.6040065 25.675"
}), /*#__PURE__*/React.createElement("path", {
  d: "M23.2637262,-2.30926389e-14 L16.874068,17.6587738 L16.1187389,13.8560113 L16.1194274,13.8573848 L13.8637679,2.31242577 C13.8637679,2.31242577 13.5917943,-2.30926389e-14 10.6847753,-2.30926389e-14 L0.123248793,-2.30926389e-14 L1.75859327e-13,0.434052001 C1.75859327e-13,0.434052001 3.23063318,1.10436015 7.00934479,3.37008413 L12.8316453,25.675 L19.814137,25.675 L30.4761905,-2.30926389e-14 L23.2637262,-2.30926389e-14",
  id: "Fill-2"
}), /*#__PURE__*/React.createElement("path", {
  d: "M67.6190476,17.775 L71.2762763,7.9 L73.3333333,17.775 L67.6190476,17.775 L67.6190476,17.775 Z M81.9047619,25.675 L76.7609971,-2.30926389e-14 L69.6906859,-2.30926389e-14 C67.3049613,-2.30926389e-14 66.7247035,1.91340012 66.7247035,1.91340012 L57.1428571,25.675 L63.8392573,25.675 L65.1793296,21.8619356 L73.3471686,21.8619356 L74.1003816,25.675 L81.9047619,25.675 Z",
  id: "Fill-3"
}), /*#__PURE__*/React.createElement("path", {
  d: "M58.139031,6.40863181 L59.047619,1.08148564 C59.047619,1.08148564 56.2419934,-2.30926389e-14 53.3172301,-2.30926389e-14 C50.1555008,-2.30926389e-14 42.6478665,1.40128692 42.6478665,8.21132904 C42.6478665,14.6199608 51.4594687,14.6995794 51.4594687,18.0641277 C51.4594687,21.428676 43.5557999,20.8275558 40.9478642,18.7050572 L40,24.2737131 C40,24.2737131 42.8442472,25.675 47.192116,25.675 C51.5393301,25.675 58.0991002,23.3919374 58.0991002,17.1830155 C58.0991002,10.7339109 49.2076366,10.1334541 49.2076366,7.32955332 C49.2076366,4.52565251 55.4126122,4.88592656 58.139031,6.40863181",
  id: "Fill-4"
}), /*#__PURE__*/React.createElement("path", {
  d: "M15.2380952,13.825 L13.1057643,2.30702161 C13.1057643,2.30702161 12.8486609,2.30926389e-14 10.1005836,2.30926389e-14 L0.116510147,2.30926389e-14 L8.52651283e-14,0.433037617 C8.52651283e-14,0.433037617 4.79904644,1.48068717 9.40282448,5.40269242 C13.8028725,9.15203078 15.2380952,13.825 15.2380952,13.825",
  id: "Fill-5"
})))));

function SvgVisa({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "120px",
    height: "80px",
    viewBox: "0 0 120 80",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref);
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVisa);
export default __webpack_public_path__ + "static/media/visa.aeb1b29f.svg";
export { ForwardRef as ReactComponent };